<template>
  <div class="main">
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCustom: false
    };
  },

  computed: {
    applyStyle() {
      return this.$store.state.style.config;
    },
    isPortalRoute() {
      return this.$route.path.startsWith('/portal');
    }
  }
};
</script>

<style lang="less" scoped>
@import '../assets/less/default';
@import '../assets/less/header';
@import '../assets/less/footer';

.main {
  height: @height;
  width: @width;
  background-color: #e3e3e3;
  overflow: hidden;
}

.main.portal-mode {
  background-color: transparent;
  background-image: none;
  overflow: auto;
}

.main-content {
  width: @width;
  height: @height;
  overflow: hidden;
}

.portal-mode .main-content {
  height: auto;
  min-height: 100%;
  overflow: auto;
}
</style>
